import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { checkIfAdmin } from "../../utils/security";
import { useUserContext } from "../../utils/userContext";

const IsAdmin = (props: {children: JSX.Element}) => {
  const { user } = useUserContext();
  const nav = useNavigate();

  useEffect(() => {
      const isAdmin = checkIfAdmin(user);
      if(!isAdmin) nav("/403");
  }, []);
  
  return  <>{props.children}</>;
};

export default IsAdmin;